$(document).ready(function () {
	$.fn.toggleAttr = function (attr, attr1, attr2) {
		return this.each(function () {
			var self = $(this);
			if (self.attr(attr) == attr1) self.attr(attr, attr2);
			else self.attr(attr, attr1);
		});
	};

	/**
	 * Hamburger toggler
	 */
	// $("button.hamburger").on("click", function () {
	// 	$("button.hamburger").toggleClass("is-active");
	// 	$("button.hamburger").attr("aria-expanded", function (index, attr) {
	// 		return attr == "false" ? "true" : "false";
	// 	});

	// 	var countryBannerHeight = $("country-selector-banner").get(
	// 		0
	// 	).offsetHeight;
	// 	$("button.hamburger").siblings().toggleClass("is-active");
	// 	$("menu-container.is-active").style.top =
	// 		countryBannerHeight + "56.17px";
	// 	$("body").toggleClass("overflow-hidden");
	// });

	$("button.hamburger").on("click", function () {
		$("button.hamburger").toggleClass("is-active");
		$("button.hamburger").attr("aria-expanded", function (index, attr) {
			return attr == "false" ? "true" : "false";
		});

		// Get country banner height - fix selector and check if element exists
		var countryBannerHeight = 0;
		var countryBanner = $("#country-selector-banner"); // Added dot for class selector

		if (countryBanner.length > 0 && countryBanner.is(":visible")) {
			countryBannerHeight = countryBanner.outerHeight(); // Use outerHeight() for total height including padding/border
		}

		$("button.hamburger").siblings().toggleClass("is-active");

		// Calculate total top position: banner height + default menu offset
		var totalTopPosition = countryBannerHeight + 52;

		// Apply the calculated top position to active menu containers
		$(".menu-container.is-active").css("top", totalTopPosition + "px");

		$("body").toggleClass("overflow-hidden");
	});

	/**
	 * Add the button role and tab-indexing to standard WP buttons for accessibility
	 */
	if ($(".wp-block-button__link").length > 0) {
		$(".wp-block-button__link")
			.attr("role", "button")
			.attr("tabindex", "0");
	}

	/**
	 * Smooth Scroll for all internal links beginning with a # (ID's)
	 */
	$(document).on("click", 'a[href^="#"]', function (e) {
		var id = $(this).attr("href");
		var $id = $(id);
		// console.log(id);
		if ($id.length === 0 || id == "#wpbb-application-form__title") {
			return;
		}
		e.preventDefault();
		var pos = $id.offset().top;
		$("body, html").animate({ scrollTop: pos }, { duration: 2000 });
	});

	if (window.outerWidth >= 1024) {
		var toggler = $("p.menu-toggler");
		$(toggler).each(function () {
			$(this).siblings("div").attr("aria-expanded", "true");
		});
	}

	if (window.outerWidth <= 1023) {
		/**
		 * Toggler for the menus in the footer mob -> tablet only
		 */
		var toggler = $("p.menu-toggler");
		$(toggler).click(function () {
			$(this).toggleClass("expanded");

			$(this)
				.siblings("div")
				.toggleAttr("aria-expanded", "true", "false");
			$(this).siblings("div").slideToggle("slow");
		});
	}

	// if (window.outerWidth >= 640) {
	// 	// Equalise the height of the news items
	// 	if ($(".job-title").length > 0) {
	// 		var highestBox = 0;
	// 		$(".job-title h2", this).each(function () {
	// 			if ($(this).height() > highestBox) {
	// 				highestBox = $(this).height();
	// 			}
	// 		});
	// 		// Set the height of all those children to whichever was highest
	// 		$(".job-title h2", this).height(highestBox);
	// 	}
	// }

	if ($(".apply-now-button").length > 0) {
		var jobTitle = $(".single-job-article-header h1").html();
		$("#wpbb-application-form__title").html(
			"<span class='has-h-5-font-size pre-job-title'>Apply for</span> " +
				jobTitle
		);
		$("input#wpbb-input-candidate_name").attr("placeholder", "Full Name *");
		$("input#wpbb-input-candidate_email").attr(
			"placeholder",
			"Email Address *"
		);
		$("input#wpbb-input-candidate_phone").attr(
			"placeholder",
			"Telephone *"
		);
		$("textarea#wpbb-input-message").attr(
			"placeholder",
			"Your cover letter/message to send to the employer"
		);
		$("#wpbb-application-form").addClass("grid-x grid-padding-x");
		$(".wpbb-application-field").addClass("cell");
		$("#wpbb-application-field-candidate_email").addClass("cell medium-6");
		$("#wpbb-application-field-candidate_phone").addClass("cell medium-6");

		$(".apply-now-button").on("click", function (e) {
			e.preventDefault();

			var application = $(
				".single-job-article-content-wrapper .wpbb-application-form__wrapper"
			);

			if ($(application).length > 0) {
				var detachment = $(application).detach();
				var svg =
					'<a href="#" class="close-modal"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.901" viewBox="0 0 24 23.901"><path d="M6.951,12.182,3.674,8.888l20.69-20.607,3.294,3.277Zm17.412,0L3.658-8.442l3.294-3.277L27.641,8.888Z" transform="translate(-3.658 11.719)" fill="#1c164e"></path></svg></a>';
				$(detachment).prependTo("body");
				$(".wpbb-application-form__wrapper").addClass(
					"grid-container full"
				);
				$(".wpbb-application-form__wrapper").attr("role", "dialog");
				$(".wpbb-application-form__wrapper").attr(
					"aria-labelledby",
					"wpbb-application-form__title"
				);
				$(".wpbb-application-form__wrapper").wrapInner(
					"<div class='wpbb-application-form__inner grid-container'><div class='grid-x'><div class='cell medium-10 medium-offset-1'></div></div></div>"
				);
				$(svg).prependTo(
					".wpbb-application-form__inner .cell.medium-10.medium-offset-1"
				);
			}
			$("#page").attr("aria-hidden", true);
			$("#page").addClass("blur");
			$(".wpbb-application-form__wrapper").addClass("open");
			$(".wpbb-application-form__wrapper.open")
				? $(
						".wpbb-application-form__wrapper.open #wpbb-input-candidate_name"
				  ).focus()
				: "";
		});

		$(".apply-now-button").click(function () {
			$(".close-modal").click(function () {
				var openApplication = $(".wpbb-application-form__wrapper.open");
				$(openApplication).removeClass("open");
				$("#page").removeClass("blur");
			});
		});
	}

	var submitButton = document.getElementById("wpbb-input-submit");
	if (submitButton) {
		// Disable the button on load
		submitButton.disabled = true;
		// console.log("Submit button disabled.");
	}

	if ($("#wpbb-application-field-consent").length > 0) {
		// Toggle the checked class on each checkbox button's parent label
		$(".wpbb-application-field-checkbox").each(function () {
			$(".wpbb-application-field-checkbox input").change(function () {
				$(this)
					.parent("label")
					.attr(
						"class",
						$(this).is(":checked")
							? "wpbb-label required checked"
							: "wpbb-label required"
					);
			});
		});

		var disclaimerText = $(
			"<p>Please note that Ernest Gordon will not initially contact candidates via WhatsApp. Ernest Gordon will never ask you to provide your bank details, passport or driving licence details during the application process.</p>"
		);

		$("#wpbb-application-field-consent").append(disclaimerText);
	}

	if ($("#jobSearchBox").length > 0) {
		$("#jobSearchBox label.facet-item-toggler").each(function () {
			$(this).click(function () {
				$(this).siblings(".facetwp-facet").slideToggle("slow");
				$(this).toggleClass("open");
				$(this).toggleClass("closed");
				$(this).siblings(".facetwp-facet").toggleClass("open");
				$(this)
					.siblings(".facetwp-facet")
					.toggleAttr("aria-expanded", "true", "false");
			});
		});
	}

	if ($(".testimonial-slider").length > 0) {
		$(".testimonial-slider").slick({
			// infinite: true,
			// autoplay: true,
			// swipeToSlide: true,
			// waitForAnimate: false,
			slide: "blockquote",
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 1000,
			dots: false,
		});
	}

	if ($(".info-slider").length > 0) {
		$(".info-slider").slick({
			// infinite: true,
			// autoplay: true,
			swipeToSlide: true,
			arrows: true,
			appendArrows: ".info-slider-arrows",
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 2500,
			dots: true,
			dotsClass: "custom_paging",
			customPaging: function (slider, i) {
				// console.log(slider);
				var slideNumber = i + 1,
					totalSlides = slider.slideCount;
				return (
					'<a class="custom-dot" role="button" title="' +
					slideNumber +
					" of " +
					totalSlides +
					'"><span class="string">0' +
					slideNumber +
					" / 0" +
					totalSlides +
					"</span></a>"
				);
			},
			asNavFor: ".custom_paging",
		});
		$(".custom_paging").slick({
			slidesToShow: 1,
			fade: true,
			asNavFor: ".info-slider",
			dots: false,
			centerMode: true,
			focusOnSelect: true,
		});
	}

	//! jobs slider

	if ($(".jobs-slider").length > 0) {
		$(".jobs-slider").slick({
			infinite: true,
			autoplay: true,
			swipeToSlide: true,
			adaptiveHeight: true,
			centerMode: true,
			arrows: true,
			slidesToShow: 5,
			slidesToScroll: 3,
			speed: 250,
			responsive: [
				{
					breakpoint: 1224,
					settings: {
						centerMode: false,
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 640,
					settings: {
						centerMode: false,
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	}

	if (window.outerWidth >= 640) {
		// Equalise the height of the news items
		const jobsSliderContainers = document.querySelectorAll(
			".wp-blt-block-job-slider"
		);

		setTimeout(() => {
			if (jobsSliderContainers.length > 0) {
				let highestBox = 0;

				Array.from(
					jobsSliderContainers[0].getElementsByClassName(
						"single-job-item slick-slide"
					)
				).forEach((slide) => {
					if (slide.offsetHeight > highestBox) {
						highestBox = slide.offsetHeight;
					}
				});

				Array.from(
					jobsSliderContainers[0].getElementsByClassName(
						"single-job-item slick-slide"
					)
				).forEach((slide) => {
					slide.style.height = `${highestBox}px`;
				});
			}
		}, 500);
	}

	if ($(".ginput_container_consent").length > 0) {
		// Toggle the checked class on each checkbox button's parent label
		$(".ginput_container_consent").each(function () {
			$(".ginput_container_consent input").change(function () {
				$(this)
					.parent("div")
					.attr(
						"class",
						$(this).is(":checked")
							? "ginput_container ginput_container_consent checked"
							: "ginput_container ginput_container_consent"
					);
			});
		});
	}
});

$(document).on("gform_post_render", function () {
	if ($("ul#gform_fields_1").length > 0) {
		$("ul#gform_fields_1").addClass("grid-x grid-margin-x");
		$(".ginput_container.ginput_container_name").addClass(
			"grid-x grid-margin-x"
		);
		$(".ginput_container.ginput_container_name > span").addClass(
			"cell small-12 large-6"
		);
	}
	if ($(".ginput_container_consent").length > 0) {
		// Toggle the checked class on each checkbox button's parent label
		$(".ginput_container_consent").each(function () {
			$(".ginput_container_consent input").change(function () {
				$(this)
					.parent("div")
					.attr(
						"class",
						$(this).is(":checked")
							? "ginput_container ginput_container_consent checked"
							: "ginput_container ginput_container_consent"
					);
			});
		});
	}
});
